export default __webpack_public_path__ + "static/media/facebook_logo.11a3100a.svg";